import { render, staticRenderFns } from "./SearchAlbumList.vue?vue&type=template&id=903808e4&"
import script from "./SearchAlbumList.vue?vue&type=script&lang=js&"
export * from "./SearchAlbumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports